import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { RecipeLite } from '../../../../../../shared/models/recipe/recipe-lite.model';
import { UntypedFormGroup } from '@angular/forms';
import { DataRefsByKey, Status } from '../../../../../../shared/models/dataref.model';
import { HistoryPopinComponent } from '../../../../../../shared/components/history-popin/history-popin.component';
import { NotificationService } from '../../../../../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-variant-tab-header',
  templateUrl: './variant-tab-header.component.html',
  styleUrls: ['./variant-tab-header.component.scss'],
  standalone: false,
})
export class VariantTabHeaderComponent implements OnChanges {
  @Input() variant?: RecipeLite | null;
  @Input() statusesRefData?: DataRefsByKey<Status> | null;
  @Input() formVariant?: UntypedFormGroup;

  @Output() saveVariant = new EventEmitter<void>();
  @Output() resetForm = new EventEmitter<void>();
  @Output() deleteVariant = new EventEmitter<void>();

  statusesOptions?: { key: string; label: string }[];

  constructor(
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.statusesRefData?.currentValue && this.statusesRefData) {
      this.statusesOptions = Object.keys(this.statusesRefData).map((statusKey: string) => ({
        key: statusKey,
        label: this.statusesRefData?.[statusKey]?.translatedName ?? statusKey,
      }));
    }
  }

  delete(): void {
    this.deleteVariant.emit();
  }

  openHistoryPopin(): void {
    if (this.variant) {
      const data = {
        resourceId: this.variant.identifier.functionalId,
        resourceType: 'RECIPE',
      };
      this.dialog.open(HistoryPopinComponent, { data });
    }
  }

  statusChange(): void {
    if (this.formVariant?.valid) {
      this.saveVariant.emit();
    } else {
      this.notificationService.sendError(this.translateService.instant('ERROR_FORM'));
    }
  }
}
